import { keyBy } from 'lodash';
import updeep from 'updeep';

import {
  SET_APPLICATIONS,
  UPDATE_APPLICATIONS,
  UPDATE_APPLICATION_RECRUITER_STATE,
  SET_MESSAGE_STATE,
} from '@src/redux/actions/applications';

const DEFAULT_STATE = {};

export function applications(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_APPLICATIONS:
      return { ...state, ...action.applications };

    case UPDATE_APPLICATIONS:
      return { ...state, ...keyBy(action.applications, 'applicationId') };

    case UPDATE_APPLICATION_RECRUITER_STATE:
      const updatedApplications = keyBy(action.applications, '_id');

      return updeep.updateIn(
        '*',
        application => {
          if (updatedApplications[application.applicationId]) {
            const { recruiterState, state } = updatedApplications[application.applicationId];

            return updeep.updateIn(
              'application',
              {
                recruiterState: {
                  state: recruiterState.state,
                  updatedAt: recruiterState.updatedAt,
                },
                state,
              },
              application,
            );
          }

          return application;
        },
        state,
      );

    case SET_MESSAGE_STATE:
      if (action.application.isUnread) {
        return updeep.updateIn(
          `${action.application.id}.application.lastUserMessage`,
          { createdAt: action.application.lastMessageDate, readByRecruiter: undefined },
          state,
        );
      }

      return updeep.updateIn(`${action.application.id}.application.lastUserMessage.readByRecruiter`, true, state);

    default:
      return state;
  }
}
